import { StyledISvgIcon, SvgImg } from './Icon.style'

export enum YoldaIcons {
  Weight,
  _10_Wheeler,
  Barrel,
  Box,
  Flatbed,
  File,
  FTL,
  HubDoneGray,
  LTL,
  NoData,
  OtherPackage,
  OtherTruck,
  Pallet,
  PriceEconomical,
  PriceExpress,
  PricePending,
  PriceStandard,
  Sack,
  SemiTruck,
  Steel,
  Tautliner,
  Truck,
  PhoneFilled,
  Pallet2,
  BoxPallet2,
  Other2,
  Box2,
  Carrier,
  TripRoute,
  CopyDone,
}

export interface IIcon {
  iconName: number
  size?: number
  hasFlag?: boolean
}

function Icon(props: IIcon) {
  return (
    <StyledISvgIcon>
      <SvgImg
        src={`/assets/icons/${YoldaIcons[props.iconName]}.svg`}
        width={props.size}
        height={props.size}
      />
    </StyledISvgIcon>
  )
}

export default Icon
